
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
    name: 'ProgressBlock',

    data() {
        return {
            activeIndexStage: 0,
        };
    },

    computed: {
        stages() {
            return this.values?.items || [];
        },
        currentStage() {
            return this.values?.items?.[this.activeIndexStage];
        },
    },

    components: {
        TimeLine: () => import('./components/ProgressBlock/TimeLine.vue'),
        Information: () => import('./components/ProgressBlock/Information.vue'),
    },

    methods: {
        changeActiveStage(activeIndexStage) {
            this.activeIndexStage = activeIndexStage;
        },
    },
});
